import type { FC } from 'react';

import type { IconProps } from './type';

export const DollarIcon: FC<IconProps> = (props) => {
  return (
    <svg
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M512 1024C229.23 1024 0 794.77 0 512S229.23 0 512 0s512 229.23 512 512-229.23 512-512 512zm51.2-256h51.2c84.831 0 153.6-68.769 153.6-153.6s-68.769-153.6-153.6-153.6H409.088c-28.277 0-51.2-22.923-51.2-51.2s22.923-51.2 51.2-51.2H716.8V256H563.2V153.6H460.8V256h-51.2C324.769 256 256 324.769 256 409.6s68.769 153.6 153.6 153.6h204.8c28.277 0 51.2 22.923 51.2 51.2s-22.923 51.2-51.2 51.2H307.2V768h153.6v102.4h102.4V768z"
        fill="currentColor"
        transform="scale(.01953)"
      />
    </svg>
  );
};
